import React from 'react'
import './bukadonasi.css'

const Upload = ({ img, ...rest }) => {
    return (
        <div className="upload">
            {img && <img className="preview" src={img} alt="" />}
            <input className="upload-image" type="file" {...rest} />
        </div>
    )
}
export default Upload;